import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tour } from "@/components/Tour";

export function TourButton({ tour, steps, auto, testid, onClose }) {
  const { user, setUser } = useAuth();
  const seen = (user?.tours_seen || []).includes(tour);
  const [open, setOpen] = useState(auto && !seen && !!user?.tutorial_seen);
  const close = () => {
    setOpen(false);
    onClose?.();
    if (!seen) {
      setUser({ ...user, tours_seen: [...(user.tours_seen || []), tour] });
      api(`/auth/tour-seen/${tour}`, { method: "POST" }).catch(() => {});
    }
  };
  return (
    <>
      <button type="button" className="icon-btn" onClick={() => setOpen(true)} title="Como usar esta tela" data-testid={testid}><HelpCircle size={17} /></button>
      <Tour steps={steps} open={open} onClose={close} />
    </>
  );
}
